import React from 'react';
import { Box, FormControlLabel, Checkbox, Typography, Button } from '@mui/material';
import UploadRow from './UploadRow';

const ChequeUploadRow = ({
  chequeFile,
  onChequeUpload,
  hasNoCheque,
  onCheckboxChange,
  bankDetails,
  onBankDialogOpen,
  onPreview,
  isOptional = false
}) => {
  return (
    <Box>
      {!hasNoCheque && (
        <>
          <UploadRow
            label="Cancelled Cheque"
            file={chequeFile}
            handler={onChequeUpload}
            isOptional={isOptional}
            onPreview={onPreview}
          />
          <Typography variant="caption" display="block" sx={{ mt: 1 }}>
            Please upload a JPG image of the cancelled cheque.
          </Typography>
        </>
      )}

      <FormControlLabel
        control={
          <Checkbox
            checked={hasNoCheque}
            onChange={onCheckboxChange}
          />
        }
        label="I don't have a cancelled cheque, but I have a bank mandate"
        sx={{
          mt: 1,
          '& .MuiFormControlLabel-label': {
            color: 'red',
            fontWeight: 'bold',
            fontSize: '0.9rem',
            fontStyle: 'italic',
          }
        }}
      />
      {hasNoCheque && bankDetails.ifsc && (
        <Button
          onClick={onBankDialogOpen}
          size="small"
          variant="text"
          sx={{ mt: 1 }}
        >
          View/Edit Bank Details
        </Button>
      )}
    </Box>
  );
};

export default ChequeUploadRow;